import { http } from "../http";
import {Company} from "../company";
import i18next from "../../../i18n";

const AccountTypes = {
    CARD: i18next.t("businessCards.cardAccount"),
    CARI : i18next.t("home.statementAccount"),
    CARD_ACCOUNT: i18next.t("home.statementCardAccount"),
    ACCOUNT : i18next.t("home.statementAccount"),
    ACC_CARD : i18next.t("home.statementCardAccount"),
}

export interface GetCustomerByIban {
    iban: string;
    customerNo: string;
    customerName: string;
    customerStatus: string;
    customerTax: string;
    customerAddress: string;
    ccy: string;
    ccyType: string;
    brAccountType: string;
    showError?: boolean
};

export interface GetCustomerBenefAccountRequest{
    pmtTypeCode : string;
    benefAcc : string;
    custAccCurr : string;
}

export interface GetCustomerBenefAccountResponse{
    IB4C_Check_BenefAcc_Resp : {
        msgStatus: string;
        msgCode: number;
        msgRemark: string;
        benefAccStatus: string;
        benefAccType: string;
        benefAccClassCode: string;
        benefAccBranchCode: string;
        benefAccCurr: string;
        benefCif: string;
        benefName: string;
        benefTaxId: string;
    }
}

export const getAccountType = (type : any) =>{
    let check_type=type==='CARD-ACCOUNT' ? 'CARD_ACCOUNT' : type;
    return typeof AccountTypes[check_type] !== undefined ? AccountTypes[check_type] : '';
}

export const GetCustomerDataByIban = async (iban: string): Promise<GetCustomerByIban> => {
    const { data } = await http.get<GetCustomerByIban>(`customers/customerbyiban/${iban}`);
    return data;
};

export const GetCustomerBenefAccountData = async (company : Company, payload: GetCustomerBenefAccountRequest): Promise<GetCustomerBenefAccountResponse> => {
    const { data } = await http.post<GetCustomerBenefAccountResponse>(`customers/${company.customerNo}/accounts/check-benef-account`, payload);
    return data;
};

